// ---------------- CORE PUSH FUNCTION ----------------

const pushEvent = (event, extra = {}) => {
  if (typeof window === "undefined") return;

  window.dataLayer = window.dataLayer || [];

  window.dataLayer.push({
    event,
    ...extra,
  });
};

/* ======================================================
   1. GLOBAL BUTTON TRACKING
====================================================== */

export const trackLoginClick = () => pushEvent("login_button_click");

export const trackSignupClick = () => pushEvent("signup_button_click");

export const trackClaimNowClick = () => pushEvent("claim_now_button_click");

export const trackRedeemNowClick = () => pushEvent("redeem_now_button_click");

/* ======================================================
   2. LOGIN FORM
====================================================== */

export const trackLoginFormSubmit = () => pushEvent("login_form_button_click");

export const trackLoginFormExit = () =>
  pushEvent("login_form_exit_button_click");

export const trackLoginWithGoogle = () =>
  pushEvent("login_form_google_button_click");

export const trackLoginWithFacebook = () =>
  pushEvent("login_form_facebook_button_click");

/* ======================================================
   3. SIGNUP FORM
====================================================== */

export const trackSignupRegistrationStart = () =>
  pushEvent("signup_form_registration_start");

export const trackSignupFormSubmit = () =>
  pushEvent("signup_form_button_click");

export const trackSignupFormExit = () =>
  pushEvent("signup_form_exit_button_click");

export const trackSignupWithGoogle = () =>
  pushEvent("signup_form_google_button_click");

export const trackSignupWithFacebook = () =>
  pushEvent("signup_form_facebook_button_click");

/* ======================================================
   4. SIGNUP ERROR TRACKING
====================================================== */

export const trackSignupPasswordError = () =>
  pushEvent("signup_form_password_error");

export const trackSignupEmailError = () => pushEvent("signup_form_email_error");

export const trackSignupFailedError = () =>
  pushEvent("signup_form_failed_error");

/* ======================================================
   5. MEMBERS LOGIN BUTTON (USED IN REG FLOW)
====================================================== */

export const trackMembersLoginClick = () => pushEvent("login_form");

export const trackRegistrationFormExit = () =>
  pushEvent("reg_form_exit_button_click");

/* ======================================================
   6. REGISTRATION STEP 1
====================================================== */

export const trackRegStep1Continue = () => pushEvent("reg_step1_button_click");

/* ======================================================
   7. REGISTRATION STEP 2
====================================================== */

export const trackRegStep2Continue = () => pushEvent("reg_step2_button_click");

export const trackRegStep2GoBack = () =>
  pushEvent("reg_step2_goback_button_click");

/* ======================================================
   8. REGISTRATION STEP 3
====================================================== */

export const trackRegStep3Play = () => pushEvent("reg_step3_button_click");

export const trackRegStep3GoBack = () =>
  pushEvent("reg_step3_goback_button_click");

/* ======================================================
   9. REGISTRATION SUCCESS
====================================================== */

export const trackRegistrationSuccess = () => pushEvent("registration_success");

/* ======================================================
   10. PHONE VERIFICATION
====================================================== */

export const trackPhoneVerificationPopup = () =>
  pushEvent("reg_verification_phone_popup");

export const trackPhoneVerificationSubmit = () =>
  pushEvent("reg_verification_phone_submitcode");

export const trackPhoneVerificationSuccess = () =>
  pushEvent("reg_verification_success");

/* ======================================================
   11. DEPOSIT EVENTS
====================================================== */

export const trackDepositClick = () => pushEvent("deposit_button_click");

export const trackDepositSubmit = () =>
  pushEvent("deposit_submit_button_click");

// TODO: Add First Deposit Success tracking in the future
export const trackFirstDepositSuccess = () =>
  pushEvent("first_deposit_success");

/* ======================================================
   12. LOGIN SUCCESS
====================================================== */

export const trackLoginSuccess = (userId) =>
  pushEvent("login", { user_id: userId });

/* ======================================================
   13. USER ID TRACKING (PAGE LOAD)
====================================================== */

export const pushUserId = (userId) => {
  if (typeof window === "undefined") return;

  window.dataLayer = window.dataLayer || [];

  window.dataLayer.push({
    user_id: userId || undefined,
  });
};

/* ======================================================
   14. GENERIC EVENT (FOR FUTURE EVENTS)
====================================================== */

export const trackCustomEvent = (eventName, data = {}) =>
  pushEvent(eventName, data);
